import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IResponseData } from 'src/app/infrastructure/models/response-data';
import { ResponseStateService } from 'src/app/infrastructure/services/response-state/response-state.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { SKIP_RESPONSE_STATE } from './skip-response-state.token';

export function responseInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_RESPONSE_STATE)) return next(request);

    const __responseStateService = injectRequired(ResponseStateService);

    return next(request)
        .pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    __responseStateService.apply(evt.body as IResponseData);
                }
            })
        );
}
